import {isFeatureEnabled} from '@github-ui/feature-flags'

interface TaskSharingPermissions {
  currentUserIsOwner: boolean
  hasRepository: boolean
  /** Whether this surface and agent type offer sharing at all. */
  supportsSharing: boolean
}

export function isTaskSharingEnabled(): boolean {
  return isFeatureEnabled('copilot_mission_control_task_sharing')
}

/**
 * Why a task's sharing status cannot be changed, or `undefined` when it can.
 *
 * Mission Control stays authoritative; this only keeps the sharing affordances
 * and the `/share` replies agreeing on one set of rules, so a surface can never
 * point at a control it does not render.
 */
export function getTaskSharingPermissionError({
  currentUserIsOwner,
  hasRepository,
  supportsSharing,
}: TaskSharingPermissions): string | undefined {
  if (!currentUserIsOwner) return 'Only the task owner can change session sharing settings.'
  if (!hasRepository) return 'Sharing requires a session attached to a repository.'
  if (!supportsSharing) return 'Sharing settings cannot be changed for this session.'
}

export function canChangeTaskSharing({
  taskId,
  ...permissions
}: TaskSharingPermissions & {taskId: string | undefined}): boolean {
  return Boolean(taskId) && isTaskSharingEnabled() && !getTaskSharingPermissionError(permissions)
}
